import { useMemo } from 'react';
import { i18n } from '@/shared/i18n';
import type { SidePanelHeaderProps } from '@/shared/ui/SidePanelWrapper/SidePanelHeader/SidePanelHeader.types';
import { SPECIAL_AGENT_IDS, useAgentCategoryChipColor } from '@/entities/agent';

interface UseExternalToolsHeaderConfigProps {
  title?: string;
}

export const useExternalToolsHeaderConfig = (
  props?: UseExternalToolsHeaderConfigProps,
): SidePanelHeaderProps => {
  const categoryChipColor = useAgentCategoryChipColor(SPECIAL_AGENT_IDS.EXTERNAL_TOOLS);

  return useMemo(
    () => ({
      chip: {
        label: props?.title || i18n.t('admin:externalToolsWidget.externalTools'),
        color: categoryChipColor,
      },
    }),
    [props?.title, categoryChipColor],
  );
};
